import { useEffect } from 'react';

const GTM_ID = process.env.REACT_APP_GTM_ID;

/**
 * GtmScript — injects Google Tag Manager (GTM) into the app.
 *
 * Loads the GTM script and initializes the dataLayer.
 * Works alongside cookieConsent — if that feature is enabled, GTM tags
 * should be configured to fire only after consent (handled in GTM via triggers).
 *
 * ENV:
 *   REACT_APP_GTM_ID — GTM container ID, e.g. GTM-XXXXXXX
 *
 * Usage:
 *   <GtmScript />
 *
 * Push events:
 *   import { pushGtmEvent } from '../features/gtm';
 *   pushGtmEvent({ event: 'purchase', value: 100 });
 */
const GtmScript = () => {
  useEffect(() => {
    if (typeof window === 'undefined' || !GTM_ID) return;

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];

    // Inject GTM script
    if (document.getElementById('gtm-script')) return;

    // noscript iframe (for browsers with JS disabled)
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.insertBefore(noscript, document.body.firstChild);

    // GTM head script
    const script = document.createElement('script');
    script.id = 'gtm-script';
    script.innerHTML = `
      (function(w,d,s,l,i){
        w[l]=w[l]||[];
        w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${GTM_ID}');
    `;
    document.head.insertBefore(script, document.head.firstChild);
  }, []); // eslint-disable-line

  return null;
};

export default GtmScript;
